/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import validationInformationsPacs from '../validationInformationsPacs';
import { validationInformationsDissolution } from '..';

const validationStep3 = (
  PACS: any,
  mode: 'initiale' | 'dissolution' | 'projet' | 'modificative',
) => {
  if(mode !== 'dissolution') {
    return ({
      ...validationInformationsPacs(
        PACS,
        PACS?.statut === 2 ? true : false,
        mode === 'projet',
      ),
    })
  } else {
    return ({
      ...validationInformationsDissolution(PACS),
    })
  }
}

export default validationStep3;
